export default __webpack_public_path__ + "static/media/Monger-HUD-Header.46bff1da.jpg";